import { IconLandscape, IconPortrait } from 'icons';

const orientationIcons: Record<string, typeof IconLandscape> = {
  portrait: IconPortrait,
  landscape: IconLandscape,
};

export default orientationIcons;
